import { render, staticRenderFns } from "./templateObligee.vue?vue&type=template&id=4978637f&scoped=true&"
import script from "./templateObligee.vue?vue&type=script&lang=js&"
export * from "./templateObligee.vue?vue&type=script&lang=js&"
import style0 from "./templateObligee.vue?vue&type=style&index=0&id=4978637f&lang=scss&scoped=true&"
import style1 from "./templateObligee.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4978637f",
  null
  
)

export default component.exports